import React from 'react';
import ShareOptionsMenu, { ShareOption } from './ShareOptionsMenu';
import { Achievement } from '../../types/goals';
import logger from '../../utils/logger';

export interface ShareAchievementButtonProps {
  achievement: Achievement;
  className?: string;
  buttonLabel?: string;
  buttonVariant?: 'primary' | 'secondary' | 'outlined' | 'text';
  buttonSize?: 'sm' | 'md' | 'lg';
}

const ShareAchievementButton: React.FC<ShareAchievementButtonProps> = ({
  achievement,
  className,
  buttonLabel = 'Share Achievement',
  buttonVariant = 'outlined',
  buttonSize = 'md',
}) => {
  const shareViaFacebook = () => {
    const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`;
    window.open(url, '_blank', 'width=600,height=400');
  };

  const shareViaTwitter = () => {
    const achievementDate = new Date(achievement.dateEarned).toLocaleDateString();
    const text = `I just earned the "${achievement.name}" achievement on Marune on ${achievementDate}!`;
    const url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(window.location.href)}`;
    window.open(url, '_blank', 'width=600,height=400');
  };

  const shareViaWhatsApp = () => {
    const achievementDate = new Date(achievement.dateEarned).toLocaleDateString();
    const text = `I just earned the "${achievement.name}" achievement on Marune on ${achievementDate}! ${window.location.href}`;
    const url = `https://wa.me/?text=${encodeURIComponent(text)}`;
    window.open(url, '_blank');
  };

  const copyLink = () => {
    navigator.clipboard.writeText(window.location.href)
      .then(() => {
        // You could show a toast notification here
        logger.info('Link copied to clipboard');
      })
      .catch(err => {
        logger.error('Failed to copy link:', err);
      });
  };

  const shareOptions: ShareOption[] = [
    {
      id: 'facebook',
      label: 'Share on Facebook',
      icon: 'facebook',
      action: shareViaFacebook
    },
    {
      id: 'twitter',
      label: 'Share on Twitter',
      icon: 'twitter',
      action: shareViaTwitter
    },
    {
      id: 'whatsapp',
      label: 'Share on WhatsApp',
      icon: 'whatsapp',
      action: shareViaWhatsApp
    },
    {
      id: 'copy',
      label: 'Copy Link',
      icon: 'link',
      action: copyLink
    }
  ];

  return (
    <ShareOptionsMenu
      options={shareOptions}
      className={className}
      buttonLabel={buttonLabel}
      buttonVariant={buttonVariant}
      buttonSize={buttonSize}
      buttonIcon="trophy"
      title={`Share Achievement: ${achievement.name}`}
    />
  );
};

export default ShareAchievementButton;